export default "__VITE_ASSET__BMmKjJru__"